module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carla Cassidy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Carla Cassidy is a "), _c('I', [_vm._v("New York Times ")]), _vm._v("bestselling author who has written more than 125 novels for Harlequin Books.  She is listed on the Romance Writer's of America Honor Roll and has won numerous awards. Carla believes the only thing better than curling up with a good book to read is sitting down at the computer with a good story to write.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/793zOm/tc-custom/9781488041204.jpg?1718169832863",
      "alt": "This image is the cover for the book Cowboy Defender, Cowboys of Holiday Ranch"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Cowboy Defender, Cowboys of Holiday Ranch\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A rancher races against the clock to save the woman he loves")]), _c('br'), _c('br'), _c('b', [_c('i', [_vm._v("Carla Cassidy’s new Cowboys of Holiday Ranch romance")])]), _c('br'), _c('br'), _vm._v("Clay “Romeo” Madison yearns to find his Juliet. So when Miranda Silver’s life is threatened, the handsome cowboy risks everything to protect the pretty single mom. After all, she might be The One. All he’s got to do is live down his scandalous reputation, persuade Miranda he’s serious…and rescue her from a kidnapper before it’s too late!\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0